module.exports = __webpack_public_path__ + "static/media/Illus-Bread_2@2x.d838333e.png";